import * as React from 'react';

import styled from '@emotion/styled';

const Svg = styled.svg`
  width: 25px;
  height: 14.656px;
  margin-right: 0.5rem;
`;

const MemoryIcon = () => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg">
        <path d="M11.207 14.656H9.483v-1.725h-.862v1.724H6.9v-1.724h-.865v1.724H4.31v-1.724h-.862v1.724H1.724A1.726 1.726 0 010 12.931v-6.9a3.05 3.05 0 00.342.018c.516 0 1.382-.114 1.382-.88v-.858c0-.77-.839-.885-1.34-.885A3.052 3.052 0 000 3.449V1.724A1.726 1.726 0 011.724 0h21.552A1.726 1.726 0 0125 1.724v1.725a2.972 2.972 0 00-.493-.04c-.562 0-1.231.157-1.231.9v.862c0 .774.816.89 1.3.89A3.1 3.1 0 0025 6.035v6.9a1.726 1.726 0 01-1.724 1.724h-1.724v-1.728h-.863v1.724h-1.724v-1.724H18.1v1.724h-1.721v-1.724h-.862v1.724h-1.724a2.337 2.337 0 00-.293-1.489.7.7 0 00-.545-.235h-.025c-.157 0-.266.006-.364.006h-.509a.734.734 0 00-.582.251 2.222 2.222 0 00-.27 1.473zm5.172-11.207v6.034h4.311V3.449zm-6.035 0v6.034h4.311V3.449zm-6.034 0v6.034h4.31V3.449z" fill="#4694ce" />
    </Svg>
  );
};

export default MemoryIcon;
